import React from "react";
import { Panel, PanelBody } from "../components/panel/panel.jsx";
import { Api } from "../app-controller.js";
import Swal from "sweetalert2";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { format } from "date-fns";

import ModalAgregar from "../components/Metas/AgregarMeta.jsx";
import ModalAsignar from "../components/Metas/AsignarMeta.jsx";

class MetasIPSA extends React.Component {
  initialState = {
    openModal: false,
    openModalAsignar: false,
    buscar: {},
    procesando: false,

    umCombo: Api.loadCatalogue("cat_poa_um"),
    fuenteCombo: Api.loadCatalogue("cat_poa_fuente_verificacion"),
    locations: Api.loadCatalogue("locations"),
    options_submetas: Api.loadCatalogue("cat_submeta_poa"),
    options_metas: [],

    nivelUsuario: localStorage.nivel_actual,

    asignar: {
      departamento_id: "",
      departamento: "",
      municipio_id: "",
      municipio: "",
      especialista_id: "",
      meta_poa_id: "",
      mes: "",
      mes_nom: "",
      anio: false,
      cantidad: "",
      nombre: "",
      descripcion_meta: "",
      fecha_inicio: "",
      fecha_final: "",
    },
    options_especialistas: [],

    options_mes: [
      { id: "0", mes: "ENERO" },
      { id: "1", mes: "FEBRERO" },
      { id: "2", mes: "MARZO" },
      { id: "3", mes: "ABRIL" },
      { id: "4", mes: "MAYO" },
      { id: "5", mes: "JUNIO" },
      { id: "6", mes: "JULIO" },
      { id: "7", mes: "AGOSTO" },
      { id: "8", mes: "SEPTIEMBRE" },
      { id: "9", mes: "OCTUBRE" },
      { id: "10", mes: "NOVIEMBRE" },
      { id: "11", mes: "DICIEMBRE" },
    ],
    acceso: 2,
    asignaciones: [],

    agregar: {
      codigo: "",
      descripcion: "",
      um_id: "",
      fuente_verificacion_id: "",
      submeta_poa_id: "",
    },
  };

  constructor(props) {
    super(props);

    this.state = this.initialState;

    this.OpenModal = this.OpenModal.bind(this);
    this.OpenModalAsignar = this.OpenModalAsignar.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.limpiarCampos = this.limpiarCampos.bind(this);
    this.mensajeError = this.mensajeError.bind(this);

    this.handleSubmit = this.handleSubmit.bind(this);

    this.handleChangeAgregar = this.handleChangeAgregar.bind(this);
    this.handleChangeAsignacion = this.handleChangeAsignacion.bind(this);

    this.addAsignacion = this.addAsignacion.bind(this);
    this.removeAsignacion = this.removeAsignacion.bind(this);

    this.handleDesactivarMeta = this.handleDesactivarMeta.bind(this);
  }

  mi_grid = {};
  componentDidMount() {
    // si el usuario no es nivel administrador ipsa redireccionamos a home
    if (this.state.nivelUsuario !== "2") {
      window.location.href = "/";
    }

    let grid = {
      source: "app/getMetasIPSA", //
      target: "#myGrid",
      tableClass: "table table-striped m-b-0 table-hover",
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando datos",
      rows: {
        tecnico: {
          label: "Nombre",
          render: (me) => {
            me.innerHTML = me.data.tecnico.toUpperCase();
          },
        },
        actividad: {
          label: "Actividad",
        },
        um: {
          label: "UM",
        },
        fuente_verificacion: {
          label: "Fuente de verificación",
        },
        submeta_poa: {
          label: "Submeta",
        },
        cantidad: {
          label: "Programado",
        },
        fecha_inicio: {
          label: "Fecha inicio",
          render: (me) => {
            me.innerHTML = me.data.fecha_inicio
              .split(" ")[0]
              .split("-")
              .reverse()
              .join("-")
              .replaceAll("-", "/");
          },
        },
        fecha_fin: {
          label: "Fecha final",
          render: (me) => {
            me.innerHTML = me.data.fecha_fin
              .split(" ")[0]
              .split("-")
              .reverse()
              .join("-")
              .replaceAll("-", "/");
          },
        },
        status: {
          label: "Estatus",
          render: (me) => {
            if (me.data.status === "0") {
              me.innerHTML = "DESACTIVADO";
            } else {
              me.innerHTML = "ACTIVADO";
            }
          },
        },
      },
      buttons: [
        {
          iconClass: "fa fa-times",
          btnClass: "btn bg-gradient-yellow",
          btnClick: (data) => {
            this.handleDesactivarMeta(data);
          },
          render: (me, data) => {
            if (data.status === 0) {
              me.remove();
            }
          },
        },
      ],
    };

    this.mi_grid = Api.grid(grid);

    let busqueda = Api.form({
      target: "#busqueda",
      render: (form) => {},
      elementClass: "form-control",
      elements: [
        {
          input: {
            type: "text",
            name: "actividad",
            label: "Actividad",
            placeHolder: "Actividad",
            cols: 4,
            value: "",
          },
        },
        {
          select: {
            cols: 4,
            name: "um",
            label: "UM",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione...</option>`;
              if (Array.isArray(this.state.umCombo)) {
                this.state.umCombo.forEach((s) => {
                  me.innerHTML += `<option value="${s.id}">${s.descripcion}</option>`;
                });
              }
            },
          },
        },
        {
          select: {
            cols: 4,
            name: "fuente_verificacion_id",
            label: "Fuente de verificación",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione...</option>`;
              if (Array.isArray(this.state.fuenteCombo)) {
                this.state.fuenteCombo.forEach((s) => {
                  me.innerHTML += `<option value="${s.id}">${s.descripcion}</option>`;
                });
              }
            },
          },
        },
        {
          input: {
            type: "text",
            name: "programado",
            label: "Programado",
            placeHolder: "Programado",
            cols: 3,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha",
            label: "Fecha inicio desde",
            cols: 3,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha2",
            label: "Fecha inicio hasta",
            cols: 3,
            value: "",
          },
        },
        {
          button: {
            name: "buscar",
            class: "form-control btn-orange",
            icon: "fa fa-search",
            cols: 3,
            text: "Buscar",
            click: (e) => {
              this.setState({ buscar: busqueda.data() });
              let search = this.state.buscar;

              let src = "";
              for (let param in search) {
                if (search[param] !== "") {
                  src += "&" + param + "=" + search[param];
                }
              }

              this.mi_grid.go(1, src);
            },
          },
        },
      ],
    });
  }

  OpenModal() {
    this.setState({ openModal: true });
  }

  OpenModalAsignar() {
    Api.loading(true);
    Api.fetch("app/getEspecialistas").then((esp) => {
      if (esp) {
        this.setState({
          openModalAsignar: true,
          options_especialistas: esp.especialistas,
          options_metas: esp.metas,
        });
      }
      Api.loading(false);
    });
  }

  handleChangeAgregar(e) {
    let agr = { ...this.state.agregar };
    agr[e.target.name] = e.target.value.toUpperCase();
    this.setState({ agregar: agr });
  }

  handleChangeAsignacion(e) {
    let asig = { ...this.state.asignar };
    const fecha = new Date();
    let fecha_inicio = "";
    let fecha_final = "";

    switch (e.target.name) {
      case "anio":
        asig[e.target.name] = e.target.checked;
        if (asig[e.target.name] === true) {
          fecha_inicio = new Date(fecha.getFullYear(), 0, 1);
          fecha_final = new Date(fecha.getFullYear(), 11, 31);

          asig["fecha_inicio"] = format(new Date(fecha_inicio), "yyyy/MM/dd"); //fecha_inicio;
          asig["fecha_final"] = format(new Date(fecha_final), "yyyy/MM/dd"); //fecha_final;

          asig["mes_nom"] = "AÑO COMPLETO";

          //this.setState({ asignar: asig });
        } else {
          //si es falso tengo que quitarle los valores que le agregue
          if (asig["mes"] !== "") {
            fecha_inicio = new Date(
              fecha.getFullYear(),
              parseInt(asig["mes"]),
              1
            );
            fecha_final = new Date(
              fecha.getFullYear(),
              parseInt(asig["mes"]) + 1,
              0
            );

            asig["fecha_inicio"] = format(new Date(fecha_inicio), "yyyy/MM/dd");
            asig["fecha_final"] = format(new Date(fecha_final), "yyyy/MM/dd");

            let mes = this.state.options_mes.find(
              (d) => d.id.toString() === asig["mes"]
            );
            asig["mes_nom"] = mes.mes;
          }
        }

        this.setState({ asignar: asig });
        return;
      case "cantidad":
        let entero = /^[1-9]\d*$/;
        if (e.target.value === "" || entero.test(e.target.value)) {
          asig["cantidad"] = e.target.value;
          this.setState({ asignar: asig });
        } else {
          return;
        }
        break;
      case "especialista_id":
        let especialista = this.state.options_especialistas.find(
          (i) => i.id.toString() === e.target.value
        );
        asig["nombre"] = especialista.nombre;
        break;
      case "meta_poa_id":
        let meta = this.state.options_metas.find(
          (m) => m.id.toString() === e.target.value
        );
        asig["descripcion_meta"] = meta.codigo + " - " + meta.descripcion;
        break;
      case "departamento_id":
        let depa = this.state.locations.departamentos.find(
          (d) => d.id.toString() === e.target.value
        );
        asig["departamento"] = depa.name.toUpperCase();
        break;
      case "municipio_id":
        let mun = this.state.locations.municipios.find(
          (m) => m.id.toString() === e.target.value
        );
        asig["municipio"] = mun.name.toUpperCase();
        break;
      case "mes":
        fecha_inicio = new Date(
          fecha.getFullYear(),
          parseInt(e.target.value),
          1
        );
        fecha_final = new Date(
          fecha.getFullYear(),
          parseInt(e.target.value) + 1,
          0
        );

        if (asig["anio"] === false) {
          asig["fecha_inicio"] = format(new Date(fecha_inicio), "yyyy/MM/dd");
          asig["fecha_final"] = format(new Date(fecha_final), "yyyy/MM/dd");

          let mes = this.state.options_mes.find(
            (d) => d.id.toString() === e.target.value
          );
          asig["mes_nom"] = mes.mes;
        }
        break;
      default:
        break;
    }

    asig[e.target.name] = e.target.value;
    this.setState({ asignar: asig });
  }

  addAsignacion(e) {
    //se puede asignar la misma tarea dos veces?
    let asignar = { ...this.state.asignar };
    if (this.validarFormulario(asignar)) {
      //si no falta nada agrego
      //tengo que validar que no se encuentre ese id en asignacion o resultado poa
      Api.loading(true);
      Api.fetch(
        "app/existeAsignacion",
        {
          esp_id: asignar["especialista_id"],
          meta_id: asignar["meta_poa_id"],
          inicio: asignar["fecha_inicio"],
          final: asignar["fecha_final"],
        },
        "post"
      ).then((esp) => {
        if (esp) {
          this.mensajeError(
            "Atención",
            "No se puede asignar esa meta debido a que el especialista ya cuenta con ella en esa fecha."
          );
          return;
        }
        Api.loading(false);
        //TENGO QUE VER SI YA SE LE ASIGNO LA MISMA TAREA AL MISMO TECNICO'
        let asig = [...this.state.asignaciones];

        for (let i in this.state.asignaciones) {
          if (
            asig[i].especialista_id === asignar.especialista_id &&
            asig[i].meta_poa_id === asignar.meta_poa_id &&
            asig[i].fecha_inicio === asignar.fecha_inicio
          ) {
            this.mensajeError(
              "Atención",
              "El especialista ya cuenta con esa tarea asignada en esa fecha."
            );
            return false;
          }
        }

        asig.push(asignar);

        asignar = this.initialState.asignar; //limpio los campos
        this.setState({ asignaciones: asig, asignar: asignar });
      });
    }
  }

  removeAsignacion(e) {
    let asig = [...this.state.asignaciones];
    asig.splice(e.target.id, 1);
    this.setState({ asignaciones: asig });
  }
  /**
   * 1 - PARA MODAL DE AGREGAR
   * 2 - PARA MODAL DE ASIGNAR
   */
  closeModal(modal) {
    Swal.fire({
      title: "¿Seguro que quiere cerrar el formulario?",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
      cancelButtonColor: "Red",
      confirmButtonColor: "#4CD964",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        if ((modal = 1)) {
          this.setState({ openModal: false });
        } else {
          this.setState({ openModalAsignar: false });
        }
        this.limpiarCampos();
      }
    });
  }

  limpiarCampos() {
    this.setState({ ...this.initialState });
  }

  mensajeError(titulo, msg) {
    Swal.fire({
      title: titulo,
      icon: "warning",
      text: msg,
    });
  }

  /**
   * 1 - PARA MODAL DE AGREGAR
   * 2 - PARA MODAL DE ASIGNAR
   */
  handleSubmit(e, modal) {
    e.preventDefault();

    switch (modal) {
      case 1: //agregar meta
        let agregar = this.state.agregar;

        if (this.validarFormulario(agregar)) {
          //regresa 0 si hay falta un campo
          Swal.fire({
            title:
              "La siguiente meta no tiene cálculo automático dentro del sistema, se le asignará manualmente al ejecutar el reporte",
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Regresar",
            cancelButtonColor: "Red",
            confirmButtonColor: "#4CD964",
            reverseButtons: true,
          }).then((result) => {
            if (result.isConfirmed) {
              Api.loading(true);
              Api.fetch("app/agregarMeta", agregar, "POST").then((data) => {
                Api.loading(false);
                Swal.fire({
                  icon: "success",
                  title: data.message,
                  timer: 3000,
                }).then(() => {
                  this.mi_grid.go(1);
                  this.setState({ openModal: false });
                  this.limpiarCampos();
                });
              });
            }
          });
        }
        break;
      case 2:
        let asignaciones = this.state.asignaciones;

        if (asignaciones.length === 0) {
          this.mensajeError(
            "Atención",
            "Favor de asegurarse que asignó al menos una meta."
          );
        } else {
          Swal.fire({
            title: "¿Seguro que desea guardar estas asignaciones?",
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Regresar",
            reverseButtons: true,
            cancelButtonColor: "Red",
            confirmButtonColor: "#4CD964",
          }).then((result) => {
            if (result.isConfirmed) {
              Api.loading(true);
              Api.fetch(
                "app/agregarAsignaciones",
                { asignaciones: asignaciones },
                "POST"
              ).then((data) => {
                Api.loading(false);
                Swal.fire({
                  icon: "success",
                  title: data.message,
                  timer: 3000,
                }).then(() => {
                  this.mi_grid.go(1);
                  this.setState({ openModalAsignar: false });
                  this.limpiarCampos();
                });
              });
            }
          });
        }
        break;
      default:
        break;
    }
  }

  validarFormulario(data) {
    for (let d in data) {
      if (data[d] === "") {
        if (d === "mes" && data["anio"] === true) {
          return 1;
        } else {
          // si alguno de mis atributos esta vacio, no agrego
          this.mensajeError("Atención", "Favor de revisar el formulario.");
          return 0;
        }
      }
    }

    return 1;
  }

  handleDesactivarMeta(data) {
    Swal.fire({
      title: "¿Seguro que desea desactivar la meta?",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Regresar",
      cancelButtonColor: "Red",
      confirmButtonColor: "#4CD964",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        Api.loading(true);
        Api.fetch("app/desactivarMeta", { id: data.id }, "put").then((data) => {
          Api.loading(false);
          Swal.fire({
            icon: "success",
            title: data.message,
            timer: 3000,
          }).then(() => {
            this.mi_grid.go(0);
          });
        });
      }
    });
  }

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">Inicio</li>
          <li className="breadcrumb-item active">Metas</li>
        </ol>
        <h1 className="page-header">Metas</h1>
        <Panel>
          <PanelBody>
            <div className="row">
              <div className="col-sm-12">
                <fieldset>
                  <div id="busqueda"></div>
                </fieldset>
                <fieldset>
                  <div className="form-group col-md-12">
                    <button
                      //type=""
                      onClick={this.OpenModalAsignar}
                      id="asignarMeta"
                      className="btn btn-info col-md-2 float-right"
                    >
                      Asignar meta
                    </button>
                    <button
                      //type=""
                      onClick={this.OpenModal}
                      id="agregarMeta"
                      className="btn btn-success col-md-2 float-right"
                    >
                      Agregar meta
                    </button>
                  </div>
                </fieldset>
                <div id="myGrid"></div>
              </div>
            </div>
          </PanelBody>
        </Panel>

        {/**Modal para agregar */}
        <Modal
          isOpen={this.state.openModal}
          tabIndex="-1"
          style={{
            maxWidth: "100%",
            width: "85%",
          }}
        >
          <ModalHeader
            toggle={() => {
              this.closeModal(1);
            }}
            className="text-center"
          >
            Agregar meta
          </ModalHeader>
          <ModalBody>
            <ModalAgregar
              //key={this.state.solicitud_id}
              component={this}
              state={this.state}
            />
          </ModalBody>
        </Modal>

        {/**Modal para Asignar */}
        <Modal
          isOpen={this.state.openModalAsignar}
          tabIndex="-1"
          style={{
            maxWidth: "100%",
            width: "85%",
          }}
        >
          <ModalHeader
            toggle={() => {
              this.closeModal(2);
            }}
            className="text-center"
          >
            Asignar meta
          </ModalHeader>
          <ModalBody>
            <ModalAsignar
              //key={this.state.solicitud_id}
              component={this}
              state={this.state}
            />
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default MetasIPSA;
